import {LqdCarouselHandler} from './lqd-carousel';

class LqdSlideshowHandler extends LqdCarouselHandler {

  onInit(...args) {

    super.onInit(...args);

    this.handleDestroy();

    this.initSplitText();
    this.initActiveOnHover();
    this.initSlideElementOnHover();

  }

  getDefaultSettings() {
    return {
      selectors: {
        splitTextElement: '[data-split-text]',
        carouselElement: '[data-lqd-flickity]',
        customAnimationElement: '[data-custom-animations]',
        slideElementOnHoverElement: '[data-slideelement-onhover]',
        activeOnHoverElement: '[data-active-onhover]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $splitTextElement: this.$element.find(selectors.splitTextElement),
      $carouselElement: this.$element.find(selectors.carouselElement),
      $customAnimationElement: this.$element.find(selectors.customAnimationElement),
      $slideElementOnHoverElement: this.$element.find(selectors.slideElementOnHoverElement),
      $activeOnHoverElement: this.$element.find(selectors.activeOnHoverElement),
    }
  }

  initSplitText() {

    this.elements.$customAnimationElement.liquidSplitText();

  }

  initSlideElementOnHover() {

    this.elements.$slideElementOnHoverElement.liquidSlideElement();

  }

  initActiveOnHover() {

    this.elements.$activeOnHoverElement.liquidSetActiveOnhover();

  }

  onDestroy() {

    this.handleDestroy();

    super.onDestroy();

  }

  handleDestroy() {

    this.handleSplitTextDestroy();
    this.handleSlideElementDestroy();
    this.handleActiveOnHoverDestroy();

  }

  handleSplitTextDestroy() {

    if ( ! this.elements.$splitTextElement.length ) return;

    const splitTextData = this.elements.$splitTextElement.data('plugin_liquidSplitText');

    if ( splitTextData ) {
      splitTextData.destroy();
    }

  }

  handleSlideElementDestroy() {

    if ( ! this.elements.$slideElementOnHoverElement.length ) return;

    const slideElementData = this.elements.$slideElementOnHoverElement.data('plugin_liquidSlideElement');

    if ( slideElementData ) {
      slideElementData.destroy();
    }

  }

  handleActiveOnHoverDestroy() {

    if ( ! this.elements.$activeOnHoverElement.length ) return;

    const activeOnHoverData = this.elements.$activeOnHoverElement.data('plugin_liquidSetActiveOnhover');

    if ( activeOnHoverData ) {
      activeOnHoverData.destroy();
    }

  }

}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdSlideshowHandler, { $element } );
}; 